import { type ReactNode, Children } from 'react';
import { isElement } from 'react-is';

import {
  Sparkline,
  SingleValueGridSparklineProps,
} from '../slots/Sparkline.js';
import { Trend, SingleValueGridTrendProps } from '../slots/Trend.js';
import { Value, SingleValueGridValueProps } from '../slots/Value.js';
import {
  SingleValueGridAccessorsConfig,
  PartialSingleValueGridConfig,
} from '../types/single-value-grid.js';

export const iterateSlots = (
  children: ReactNode,
): PartialSingleValueGridConfig & {
  accessors: SingleValueGridAccessorsConfig;
} => {
  const slots: PartialSingleValueGridConfig = {};
  const accessors: SingleValueGridAccessorsConfig = {};

  Children.forEach(children, (child) => {
    if (isElement(child)) {
      switch (child.type) {
        case Value: {
          const {
            dataAccessor,
            formatterAccessor,
            unitAccessor,
            ...valueProps
          } = child.props as SingleValueGridValueProps;

          slots.value = valueProps as SingleValueGridValueProps;

          accessors.value = {
            dataAccessor,
            formatterAccessor,
            unitAccessor,
          };
          break;
        }
        case Sparkline: {
          const { dataAccessor, colorAccessor, ...sparklineProps } =
            child.props as SingleValueGridSparklineProps;

          slots.sparkline = sparklineProps as SingleValueGridSparklineProps;

          accessors.sparkline = {
            dataAccessor,
            colorAccessor,
          };
          break;
        }
        case Trend: {
          const {
            directionAccessor,
            valueAccessor,
            labelAccessor,
            formatterAccessor,
            inverseTrendAccessor,
            ...trendProps
          } = child.props as SingleValueGridTrendProps;

          slots.trend = trendProps as SingleValueGridTrendProps;

          accessors.trend = {
            directionAccessor,
            valueAccessor,
            labelAccessor,
            formatterAccessor,
            inverseTrendAccessor,
          };
          break;
        }
      }
    }
  });

  return { ...slots, accessors };
};
